export const selectImage = (images, key) => {
  let selectedImg = images.find(img => img[key] === true);
  if (typeof selectedImg === 'undefined') selectedImg = images[0];
  return selectedImg;
};

export const spaceTo_ = (str) => str.replace(/ /g,'_');

export const _ToSpace = (str) => str.replace(/_/g,' ');
